import { BROWSER_TEST_PROGRESS } from "../actions/constants";
import { BROWSER_TEST } from "../actions/types";

const initialState = {
  error: null,
  isLoading: false,
  lang: null,
  logId: null,
  userId: null,
  screenerDraftId: null,
  exitText: null,
  isScreener: null,
  screenerSetId: null,
  screenerResponseId: null,
  testDetails: {},
  testDataFetched: false,
  countries: [],
  susStartTime: null,
  susEndTime: null,
  susAnswers: [],
  progress: BROWSER_TEST_PROGRESS.LANGUAGE_SELECTION,
  taskResponses: [],
  previewError: false,
};

const browserTestReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case BROWSER_TEST.UPDATE:
      return { ...state, isLoading: false, error: null, ...payload };

    case BROWSER_TEST.RESET:
      return initialState;

    case BROWSER_TEST.ERROR:
      return { ...state, isLoading: false, error: payload };

    default:
      return state;
  }
};

export default browserTestReducer;
